export default __webpack_public_path__ + "static/media/up_scroll_icon.ee7d82c6.png";